module.exports = __webpack_public_path__ + "img/academy-hero-background.158dff11.svg";